import  React from 'react';

export type BgisSearchBodyProps = {
  children?: React.ReactNode;
};

export const BgisSearchBody : React.FC<BgisSearchBodyProps> = ({ children }) => {

  return (
    <div className='bgis-search-body'>{children}</div>
  );
};
